import { STORAGE_KEY } from "../constants.js";
const createThemeSlice = () => (set, get) => ({
  theme: null,
  actions: {
    setTheme(theme) {
      const {
        storage
      } = get();
      storage.set(STORAGE_KEY.theme, theme ?? "");
      document.body.classList.remove("graphiql-light", "graphiql-dark");
      if (theme) {
        document.body.classList.add(`graphiql-${theme}`);
        document.documentElement.setAttribute("data-theme", theme);
      } else {
        document.documentElement.removeAttribute("data-theme");
      }
      set({
        theme
      });
    }
  }
});
export {
  createThemeSlice
};
//# sourceMappingURL=theme.js.map
